<template functional>
  <v-list-item-content>
    <v-list-item-title v-if="props.item.type === 'sign'">{{ props.item.propertyName }}</v-list-item-title>
    <v-list-item-title v-else>{{ props.item.name }} <span v-if="props.item.type === 'contact' && !!props.item.company"> – {{ props.item.company }}</span></v-list-item-title>
  </v-list-item-content>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'AssociatedItem',

  props: {
    item: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },
  },
});
</script>
